import React from 'react';

import { ListItemButton, ListItemIcon, ListItemText } from 'components';

type Props = {
  isMobile: boolean;
  isCollapsed?: boolean;
  icon?: React.ReactNode;
  title: string;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const NavigationItem: React.FC<Props> = ({
  handleClick,
  isMobile,
  isCollapsed,
  icon,
  title,
}) => {
  return (
    <ListItemButton
      component="button"
      disableRipple
      onClick={handleClick}
      sx={{
        width: '100%',
        padding: isMobile ? '10px 20px' : '10px 24px',
        borderLeft: '3px solid transparent',
        borderRadius: 0,
        gap: '12px',
        color: 'text.secondary',
        fontWeight: 500,
        transition: 'all 0.3s ease',
        '&:hover': {
          bgcolor: '#F9FAFB',
          color: '#32363F',
        },
      }}
    >
      {icon && (
        <ListItemIcon
          sx={{
            minWidth: 'unset',
            color: 'inherit',
            '& .MuiSvgIcon-root': { fontSize: '20px', color: 'inherit' },
          }}
        >
          {icon}
        </ListItemIcon>
      )}
      {!isCollapsed && (
        <ListItemText
          primary={title}
          primaryTypographyProps={{
            fontSize: '14px',
            fontWeight: 'inherit',
            fontFamily: 'Montserrat, sans-serif',
            color: 'inherit',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        />
      )}
    </ListItemButton>
  );
};
